import React from 'react';

const OnlineTrafikSigortasi1 = ({ onStart }) => {
  return (
    <div className="max-w-5xl mx-auto px-4">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center min-h-[70vh]">

        {/* Sol: Sigo Maskot */}
        <div className="flex flex-col items-center order-1 lg:order-1">
          <div className="w-52 h-52 sm:w-64 sm:h-64 lg:w-72 lg:h-72 animate-sigo-float">
            <img
              src="/sigo.png"
              alt="Sigo - Uygun Fiyat Odaklı Sigorta Asistanı"
              className="w-full h-full object-contain drop-shadow-2xl"
            />
          </div>
        </div>

        {/* Sag: Tanitim */}
        <div className="order-2 lg:order-2 text-center lg:text-left lg:-ml-16">

          {/* Baslik */}
          <h1 className="text-3xl sm:text-4xl font-extrabold text-gray-900 leading-tight mb-2">
            SiGo
          </h1>
          <p className="mb-4 text-lg sm:text-xl font-semibold leading-relaxed">
            <span className="bg-[#0189ec] text-white px-1 py-0.5 box-decoration-clone">Uygun Fiyat Odaklı Sigorta Asistanınız</span>
          </p>

          {/* Konusma Balonu */}
          <div className="relative bg-white rounded-2xl shadow-lg border border-orange-100 p-5 sm:p-6 mb-6 animate-chat-bubble">
            <div className="absolute -top-3 left-8 lg:left-12 w-5 h-5 bg-white border-l border-t border-orange-100 transform rotate-45" />
            <p className="text-gray-800 font-semibold text-base sm:text-lg leading-relaxed">
              Merhaba! Ben SiGo, Uygun Fiyat Odaklı Sigorta Robotuyum.
            </p>
            <p className="text-gray-500 text-sm sm:text-base mt-2 leading-relaxed">
              Sigorta şirketlerini saniyeler içinde tarayıp, bütçenize en uygun trafik sigortasını bulacağım. Hadi başlayalım!
            </p>
          </div>

          {/* Hemen Fiyat Al Butonu */}
          <button
            onClick={onStart}
            className="w-full sm:w-auto px-10 py-4 rounded-lg bg-[#0189ec] hover:bg-[#0070c9] text-white font-bold text-lg shadow-lg shadow-blue-200/40 hover:shadow-xl hover:shadow-blue-300/50 transition-all active:scale-[0.98] flex items-center justify-center gap-3 mx-auto lg:mx-0"
          >
            Hemen Fiyat Al
          </button>

        </div>
      </div>
    </div>
  );
};

export default OnlineTrafikSigortasi1;
